import api from './api';

export const authService = {

  login: async (email, password) => {

    const response = await api.post('/auth/login.php', { email, password });

    return response.data;

  },



  register: async (data) => {

    const response = await api.post('/auth/register.php', data);

    return response.data;

  },



  verifyOTP: async (email, otp) => {

    const response = await api.post('/auth/verify-otp.php', { email, otp });

    return response.data;

  },



  logout: () => {

    localStorage.removeItem('access_token');

    localStorage.removeItem('refresh_token');

    localStorage.removeItem('user');

  },



  getCurrentUser: () => {

    try {

      const userStr = localStorage.getItem('user');

      return userStr ? JSON.parse(userStr) : null;

    } catch (e) {

      localStorage.removeItem('access_token');

      localStorage.removeItem('refresh_token');

      localStorage.removeItem('user');

      return null;

    }

  },



  isAuthenticated: () => {

    return !!localStorage.getItem('access_token');

  },

};
